<template>
    <div class="q-pa-lg">
        <div class="row justify-between items-start">
            <h1>Конфигурации проектов в облаке</h1>
        </div>
        <mcp-project-configs ref="mcpProjectConfigs"/>
    </div>
</template>

<script>
import {
  QBtn
} from 'quasar';
import McpProjectConfigs from "../components/McpProjectConfigs";

export default {
  name: 'McpProjectConfigsView',
  components: {
    QBtn,
    McpProjectConfigs,
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/McpProjectConfigsView.vue